/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.modals.remove.controllers', [
  'ui.bootstrap'
])

.controller('MembershipOfferingsModalsRemoveController', ['$scope', '$uibModalInstance', 'currentOffering', function($scope, $uibModalInstance, currentOffering) {

    $scope.membershipOfferingsModalsRemove = {

      model: {},

      init: function() {
        if (currentOffering) {
          this.model = currentOffering;
        }
      },

      done: function() {
        $uibModalInstance.close();
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipOfferingsModalsRemove.init();

}]);